import type { FaireBrandEntity } from "../../entity_types/brand";

export const state_the_label: FaireBrandEntity = {
  token: "state-the-label",
  type: "brand",
  name: "State The Label",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 312,
  isTopShop: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
